import { RESET_STATE_TO_INITIAL } from './actionTypes';

const resetStateToInitial = propsToIgnore => ({
    type: RESET_STATE_TO_INITIAL,
    payload: propsToIgnore,
});

export default resetStateToInitial;
